/*
 * Ventana «Personalizar producto» de Markegifts: técnicas en tarjetas con icono, nombre claro, para qué sirve, medidas
 * y precio orientativo del marcaje; los colores, en botones. Por dentro mandan los desplegables de siempre
 * (.tecnica-select y .colores-select): las tarjetas solo los cambian. El precio sale de quoteAreaCost (calculator.js),
 * con 1 color y las unidades elegidas.
 */
(() => {
  const acordeon = document.getElementById('areasAccordion');
  if (!acordeon || acordeon.dataset.tarjetas) return;
  acordeon.dataset.tarjetas = '1';

  const svg = (d) =>
    `<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;
  const ICONOS = {
    serigrafia: svg('<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M7 8h10M7 11.5h6"/><path d="M5 20h14M9 16v4M15 16v4"/>'),
    tampografia: svg('<path d="M9 3h6v4a3 3 0 0 0 3 3v3H6v-3a3 3 0 0 0 3-3z"/><path d="M5 16h14v4H5z"/>'),
    dtf: svg('<rect x="4" y="3" width="12" height="16" rx="2"/><circle cx="10" cy="9" r="2.5"/><path d="M7 15h6"/><path d="M19 7v11a3 3 0 0 1-3 3H8"/>'),
    transfer: svg('<path d="M4 15h16l-2.5-7H9a5 5 0 0 0-5 5z"/><path d="M9 8V5h7"/><path d="M6 19.5c1.2-1 2.4 1 3.6 0s2.4 1 3.6 0 2.4 1 3.6 0"/>'),
    laser: svg('<path d="M9 3h6v6l-3 3-3-3z"/><path d="M12 12v4"/><path d="M8.5 17.5L12 16l3.5 1.5"/><path d="M4 21h16"/>'),
    digital: svg('<path d="M7 8V3h10v5"/><rect x="3" y="8" width="18" height="8" rx="2"/><path d="M7 13h10v8H7z"/>'),
    sublimacion: svg('<path d="M12 3s5 5.5 5 9a5 5 0 0 1-10 0c0-3.5 5-9 5-9z"/><path d="M3 21c1.5-1.2 3 1.2 4.5 0s3 1.2 4.5 0 3 1.2 4.5 0 3 1.2 4.5 0"/>'),
    termograbado: svg('<path d="M12 3c2 2.5 4 4 4 7a4 4 0 0 1-8 0c0-1.8 1-3 2-4 0 1.6.8 2.6 2 2.6 0-2-1-3.6 0-5.6z"/><path d="M4 20h16"/>'),
    resina: svg('<path d="M4 17a8 8 0 0 1 16 0z"/><path d="M3 17h18"/><path d="M9 12.5a3.5 3.5 0 0 1 3-2.5"/>'),
    etiqueta: svg('<path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.5"/>'),
    bordado: svg('<path d="M20 4L9.5 14.5"/><path d="M17.5 3l3.5 3.5"/><path d="M9.5 14.5c-3 1-5 3-4 5s4.2 0 5-3"/>'),
    otra: svg('<path d="M4 20c2.5 0 4.5-1.2 4.5-3.5 0-1.2-1-2-1-2L17 5l3 3-9.5 9.5"/>'),
  };
  // El orden importa: DTF antes que transfer, termograbado antes que láser, etiqueta antes que digital.
  // todoColor: a todo color aunque el proveedor diga «1 color» (así lo cobra la calculadora)
  const FAMILIAS = [
    { re: /dtf/i, nombre: 'DTF', frase: 'Se imprime en un film y se fija con calor. A todo color: fotos, degradados y detalles finos.', icono: 'dtf', todoColor: true },
    // Los dos transfer de Makito (MKTGifts, MKTextil)
    { re: /transfer.*digital/i, nombre: 'Transfer digital', frase: 'A todo color, impreso en lámina y fijado con calor.', icono: 'transfer', todoColor: true },
    { re: /transfer.*serigr/i, nombre: 'Transfer serigráfico', frase: 'Colores planos impresos en lámina y fijados con calor.', icono: 'transfer' },
    { re: /serigraf.*circular/i, nombre: 'Serigrafía circular', frase: 'Serigrafía que rodea piezas cilíndricas, como vasos o botellas.', icono: 'serigrafia' },
    { re: /serigraf/i, nombre: 'Serigrafía', frase: 'Tinta directa. Ideal para logos de pocos colores y muchas unidades.', icono: 'serigrafia' },
    { re: /tampograf/i, nombre: 'Tampografía', frase: 'Para piezas pequeñas o curvas, como bolígrafos o llaveros.', icono: 'tampografia' },
    { re: /termograbad/i, nombre: 'Termograbado', frase: 'Marcado con calor y presión, en bajorrelieve. Muy elegante.', icono: 'termograbado' },
    { re: /360.*l[aá]ser|l[aá]ser.*360/i, nombre: 'Grabado láser 360°', frase: 'Grabado permanente que rodea toda la pieza.', icono: 'laser' },
    { re: /retroilumin/i, nombre: 'Láser retroiluminado', frase: 'Grabado que deja pasar la luz del producto.', icono: 'laser' },
    { re: /l[aá]ser|grabado/i, nombre: 'Grabado láser', frase: 'Grabado permanente sin tinta, sobre metal, madera o cristal.', icono: 'laser' },
    { re: /sublimaci/i, nombre: 'Sublimación', frase: 'La tinta se funde con el material. Todo color sobre fondos claros.', icono: 'sublimacion' },
    { re: /etiqueta/i, nombre: 'Etiqueta adhesiva', frase: 'Adhesivo impreso a todo color.', icono: 'etiqueta' },
    { re: /transfer/i, nombre: 'Transfer', frase: 'Diseño impreso en lámina y fijado con calor. Admite varios colores.', icono: 'transfer', fraseSegunColores: true },
    { re: /resina|doming|gota/i, nombre: 'Resina', frase: 'Etiqueta a todo color con relieve de resina transparente.', icono: 'resina' },
    { re: /digital.*360|360.*digital/i, nombre: 'Impresión digital 360°', frase: 'A todo color, alrededor de toda la pieza.', icono: 'digital' },
    { re: /digital|uv|impresi/i, nombre: 'Impresión digital', frase: 'A todo color, también fotos y degradados.', icono: 'digital' },
    { re: /bordad/i, nombre: 'Bordado', frase: 'Hilo cosido: acabado premium y muy duradero.', icono: 'bordado' },
  ];
  const familiaDe = (nombre) =>
    FAMILIAS.find((f) => f.re.test(nombre || '')) || { nombre: String(nombre || '').trim(), frase: '', icono: 'otra' };
  const euros = (n) => (typeof formatMoney === 'function' ? formatMoney(n) : `${n.toFixed(2).replace('.', ',')} €`);
  // Medidas: la calculadora de Markegifts trabaja en mm (marcajeDimToMm); la de MKTGifts y MKTextil, en cm
  // (window.marcajeEnCm). Para enseñarlas, siempre en mm; para calcular, en las de la tienda.
  const medidaCalculo = (v) => (typeof marcajeDimToMm === 'function' ? marcajeDimToMm(v, window.productVendor) : Number(v));
  const mm = (v) => (typeof marcajeDimToMm === 'function' ? marcajeDimToMm(v, window.productVendor) : Number(v) * (window.marcajeEnCm ? 10 : 1));
  const sinCliche = (t) => typeof sinClicheEnTecnica === 'function' && sinClicheEnTecnica(t.code_tec_ref);
  const unidades = () => [...document.querySelectorAll('.qty-input')].reduce((s, i) => s + (parseInt(i.value, 10) || 0), 0);

  function datosDe(t) {
    const max = parseInt(t.colores_max, 10);
    const colores = !familiaDe(t.nombre).todoColor && !isNaN(max) && max > 0 ? `Hasta ${max} color${max > 1 ? 'es' : ''}` : 'Todo color';
    const ancho = mm(t.ancho);
    const alto = mm(t.alto);
    return ancho && alto ? `${colores}. Hasta ${ancho} × ${alto} mm` : colores;
  }

  function precioDe(t, item) {
    const uds = unidades();
    if (!uds || typeof quoteAreaCost !== 'function') return '';
    try {
      let ancho = medidaCalculo(t.ancho);
      let alto = medidaCalculo(t.alto);
      // Donde el cliente escribe el tamaño de su diseño (MKTGifts, MKTextil), con ese tamaño si es menor
      const aIn = item && item.querySelector('.ancho-input');
      const hIn = item && item.querySelector('.alto-input');
      if (aIn && hIn && !aIn.readOnly && Number(aIn.value) > 0 && Number(hIn.value) > 0) {
        ancho = Math.min(ancho, Number(aIn.value));
        alto = Math.min(alto, Number(hIn.value));
      }
      // …o con lo que mide su diseño, si lo ha dicho en «¿Cuánto mide tu diseño?» (Markegifts; en mm, como la cuenta)
      const disenoAncho = Number(item && item.dataset.disenoAncho);
      const disenoAlto = Number(item && item.dataset.disenoAlto);
      if (disenoAncho > 0 && disenoAlto > 0 && typeof medidaDentro === 'function') {
        [ancho, alto] = medidaDentro(disenoAncho, disenoAlto, ancho, alto);
      }
      const c = quoteAreaCost(t, '1', false, ancho, alto, uds);
      const porUnidad = c.subTotalArea / uds;
      return Number.isFinite(porUnidad) && porUnidad > 0 ? `Marcaje desde ${euros(porUnidad)}/u` : '';
    } catch (e) {
      return '';
    }
  }

  function pintar(item) {
    const sel = item && item.querySelector('.tecnica-select');
    const colSel = item && item.querySelector('.colores-select');
    if (!sel || !colSel || typeof areasData === 'undefined') return;
    const area = areasData[parseInt(sel.dataset.area, 10)];
    if (!area) return;

    // Lo que mide la zona (la técnica que más deja marcar), en la cabecera: con las tarjetas ya no hay campos de medidas
    // (al final de los textos: tras el «Área N», o tras el nombre si la zona ya se llama así)
    const textos = item.querySelector('.mk-area__textos');
    if (textos && !item.querySelector('.mk-area__medida')) {
      const conMedida = (area.tecnicas || []).filter((t) => Number(mm(t.ancho)) > 0 && Number(mm(t.alto)) > 0);
      const mayor = conMedida.sort((x, y) => mm(y.ancho) * mm(y.alto) - mm(x.ancho) * mm(x.alto))[0];
      if (mayor) {
        const enCm = (v) => String(Math.round(Number(mm(v))) / 10).replace('.', ',');
        textos.insertAdjacentHTML('beforeend', `<span class="mk-area__medida">Hasta ${enCm(mayor.ancho)} × ${enCm(mayor.alto)} cm</span>`);
      }
    }

    let caja = item.querySelector('.mk-tecnicas-caja');
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'mk-tecnicas-caja';
      sel.closest('.row').before(caja);
      item.classList.add('mk-con-tarjetas');
    }

    // Algunos proveedores (PF Concept) repiten la misma técnica idéntica varias veces: una sola tarjeta por técnica
    const clave = (t) => (t ? [t.nombre, t.colores_max, t.ancho, t.alto, t.code_tec_ref].join('|') : '');
    // La primera opción, «Elige técnica» (vacía), no es una tarjeta: ninguna técnica viene elegida
    const conValor = [...sel.options].filter((o) => o.value !== '');
    const primera = {};
    conValor.forEach((o) => {
      const k = clave(area.tecnicas[parseInt(o.value, 10)]);
      if (!(k in primera)) primera[k] = o.value;
    });
    const elegida = sel.value === '' ? '' : primera[clave(area.tecnicas[parseInt(sel.value, 10)])] ?? sel.value;
    const opciones = conValor.filter((o) => primera[clave(area.tecnicas[parseInt(o.value, 10)])] === o.value);
    const tecnicas = opciones.map((o) => area.tecnicas[parseInt(o.value, 10)]);
    const familias = tecnicas.map((t, k) => familiaDe(t?.nombre || opciones[k].textContent));
    // Si una zona tiene varias de la misma familia (p. ej. Transfer [N4] y Transfer [O1]), se distinguen por sus
    // colores; el código del proveedor solo si aun así coinciden
    const porColores = (t, f) => {
      const max = parseInt(t.colores_max, 10);
      return !isNaN(max) && max > 0 ? `${f.nombre} hasta ${max} color${max > 1 ? 'es' : ''}` : `${f.nombre} a todo color`;
    };
    // …y si tienen los mismos colores, por su tamaño (DTF 10x10 y 25x28)
    const cm = (v) => String(Math.round((Number(mm(v)) / 10) * 10) / 10).replace('.', ',');
    const nombres = tecnicas.map((t, k) => {
      const f = familias[k];
      const hermanas = tecnicas.filter((u, j) => u && familias[j].nombre === f.nombre);
      // El DTF se cobra por superficie: siempre con su tamaño, aunque solo haya uno
      if (t && f.icono === 'dtf' && Number(t.ancho) > 0 && Number(t.alto) > 0) return `${f.nombre} hasta ${cm(t.ancho)} × ${cm(t.alto)} cm`;
      if (!t || hermanas.length < 2) return f.nombre;
      if (new Set(hermanas.map((u) => String(u.colores_max))).size > 1) return porColores(t, f);
      if (new Set(hermanas.map((u) => `${u.ancho}x${u.alto}`)).size > 1) return `${f.nombre} hasta ${cm(t.ancho)} × ${cm(t.alto)} cm`;
      return porColores(t, f);
    });
    const tarjetas = opciones.map((o, k) => {
      const t = tecnicas[k];
      if (!t) return '';
      const f = familias[k];
      // El transfer del proveedor, distinto según sus colores, para no confundirlo con el DTF
      const maxColores = parseInt(t.colores_max, 10);
      const frase = !f.fraseSegunColores ? f.frase
        : !isNaN(maxColores) && maxColores > 0 ? 'Colores planos impresos en lámina y fijados con calor.' : 'A todo color, impreso en lámina y fijado con calor.';
      const codigo = (String(t.nombre).match(/\[([^\]]+)\]/) || [])[1];
      const nombre = nombres.filter((n) => n === nombres[k]).length > 1 && codigo ? `${nombres[k]} (${codigo})` : nombres[k];
      return `<button type="button" class="mk-tecnica" role="radio" aria-checked="${o.value === elegida}" data-valor="${o.value}">
        <span class="mk-tecnica__icono">${ICONOS[f.icono]}</span>
        <span class="mk-tecnica__nombre">${nombre}</span>
        ${sinCliche(t) ? `<span class="mk-tecnica__promo">${typeof SIN_CLICHE !== 'undefined' ? SIN_CLICHE.corto : 'Sin cliché'}</span>` : ''}
        ${frase ? `<span class="mk-tecnica__frase">${frase}</span>` : ''}
        <span class="mk-tecnica__datos">${datosDe(t)}</span>
        <span class="mk-tecnica__precio" data-precio>${precioDe(t, item)}</span>
      </button>`;
    });
    const colores = [...colSel.options].map((o) => {
      const texto = /full/i.test(o.value) ? 'Todo color' : o.value;
      return `<button type="button" class="mk-color${/^\d+$/.test(texto) ? ' mk-color--num' : ''}" role="radio" aria-checked="${o.value === colSel.value}" data-valor="${o.value}">${texto}</button>`;
    });

    caja.innerHTML = `
      <p class="mk-tecnicas__titulo">${elegida === '' ? 'Elige la técnica' : 'Técnica'}</p>
      <div class="mk-tecnicas" role="radiogroup" aria-label="Técnica">${tarjetas.join('')}</div>
      ${
        colores.length > 1
          ? `<p class="mk-tecnicas__titulo">Colores de tu diseño</p>
      <div class="mk-colores" role="radiogroup" aria-label="Colores de tu diseño">${colores.join('')}</div>`
          : ''
      }`;
  }

  function preciosAlDia() {
    acordeon.querySelectorAll('.mk-con-tarjetas').forEach((item) => {
      const sel = item.querySelector('.tecnica-select');
      const area = typeof areasData !== 'undefined' ? areasData[parseInt(sel.dataset.area, 10)] : null;
      if (!area) return;
      item.querySelectorAll('.mk-tecnica').forEach((b) => {
        const t = area.tecnicas[parseInt(b.dataset.valor, 10)];
        const hueco = b.querySelector('[data-precio]');
        const texto = t ? precioDe(t, item) : '';
        if (hueco && hueco.textContent !== texto) hueco.textContent = texto;
      });
    });
  }

  acordeon.addEventListener('click', (e) => {
    const tarjeta = e.target.closest('.mk-tecnica');
    const color = e.target.closest('.mk-color');
    if (!tarjeta && !color) return;
    const item = e.target.closest('.accordion-item');
    if (tarjeta) {
      const sel = item.querySelector('.tecnica-select');
      sel.value = tarjeta.dataset.valor;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      // Elegir técnica en una zona sin marcar la marca: si no, no entraría en el presupuesto
      const chk = item.querySelector('.area-checkbox');
      if (chk && !chk.checked) {
        chk.checked = true;
        chk.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      const colSel = item.querySelector('.colores-select');
      colSel.value = color.dataset.valor;
      colSel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    pintar(item);
  });

  // La calculadora pinta las zonas al abrir la ventana y rehace los colores al cambiar de técnica
  acordeon.addEventListener('change', (e) => {
    if (e.target.matches('.tecnica-select, .colores-select')) pintar(e.target.closest('.accordion-item'));
  });
  new MutationObserver(() => {
    acordeon.querySelectorAll('.accordion-item:not(.mk-con-tarjetas)').forEach(pintar);
  }).observe(acordeon, { childList: true });
  const total = document.getElementById('grandTotal');
  if (total) new MutationObserver(preciosAlDia).observe(total, { childList: true, characterData: true, subtree: true });
})();
